import gaRouteUpdate from "@v4/utils/gaRouteUpdate";
import "./src/styles/global.css";

export const onRouteUpdate = ({ location }) => {
    // Send Pageviews to GA
    gaRouteUpdate(window, location);
};
